import { render, staticRenderFns } from "./MerchantAndMerBinDings.vue?vue&type=template&id=5724d3b6&scoped=true&"
import script from "./MerchantAndMerBinDings.vue?vue&type=script&lang=ts&"
export * from "./MerchantAndMerBinDings.vue?vue&type=script&lang=ts&"
import style0 from "./MerchantAndMerBinDings.vue?vue&type=style&index=0&id=5724d3b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5724d3b6",
  null
  
)

component.options.__file = "MerchantAndMerBinDings.vue"
export default component.exports